import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";

export const ConfigurationPricingFooterProfiel = () => {
  const { layout, calculateExtrasPrice, getConfiguredOptionPrices } =
    useConfigurationOptionsContext();
  const configuredOptionPrices = getConfiguredOptionPrices();

  // Get the price of each option
  const colorPrice = "€" + configuredOptionPrices.color.toFixed(2);

  // Layout price and name
  const layoutPrice = "€" + configuredOptionPrices.layout.toFixed(2);
  const layoutName = layout?.name || "Layout";

  // Calculate the total price of extras
  const extraTotal = calculateExtrasPrice();
  const extrasPrice = "€" + extraTotal.toFixed(2);

  return (
    <div className="gg-flex">
      <div className="gg-grid gg-h-min gg-grid-cols-2 gg-items-center gg-gap-x-5 gg-gap-y-2.5 gg-text-xs sm:gg-h-full sm:gg-gap-y-[1px] sm:gg-text-sm">
        {/* Kleur */}
        <h5 className="gg-font-semibold gg-text-dark-blue">Kleur</h5>
        <p className="gg-text-xs gg-text-purple-300">{colorPrice}</p>

        {/* Glas */}
        <h5 className="gg-font-semibold gg-text-dark-blue">{layoutName}</h5>
        <p className="gg-text-xs gg-text-purple-300">{layoutPrice}</p>

        {/* Extras */}
        <h5 className="gg-font-semibold gg-text-dark-blue">Extras</h5>
        <p className="gg-text-xs gg-text-purple-300">{extrasPrice}</p>
      </div>
    </div>
  );
};
